// @flow
import React from 'react';

const Loader = () => (
  <div className="loader-wrapper d-flex align-items-center">
    <div className="loader" />
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js